import { HttpErrorResponse } from '@angular/common/http';

/** API messages of the agreement and course endpoints, in the words of the panel. */
const MESSAGES: [string, string][] = [
  ['template has already been used', 'Ten wzorzec skopiowały już szkoły - można go tylko zarchiwizować.'],
  ['agreement has already been used', 'Tę umowę wygenerowano już dla kursanta - można ją tylko zarchiwizować.'],
  ['course has already been used', 'Ten kurs był już użyty w umowie kursanta - można go tylko zarchiwizować.'],
  ['archived agreement cannot be chosen', 'Do kursu nie można przypisać zarchiwizowanej umowy.'],
  ['agreement is archived', 'Wybrana umowa jest zarchiwizowana.'],
  ['course is archived', 'Wybrany kurs jest zarchiwizowany.'],
  ['template is not available', 'Wybrany wzorzec nie jest już dostępny.'],
  ['content is required', 'Treść umowy nie może być pusta.'],
  ['agreement is too long', 'Treść umowy jest zbyt długa.'],
  ['name is required', 'Podaj nazwę.'],
  ['needs at least one installment', 'Kurs płatny w ratach musi mieć co najmniej jedną ratę.'],
  ['at most 24 installments', 'Kurs może mieć najwyżej 24 raty.'],
  ['Every installment must be', 'Każda rata musi mieć kwotę większą od zera (najwyżej 2 miejsca po przecinku).'],
  ['Course price must be', 'Podaj poprawną cenę kursu (najwyżej 2 miejsca po przecinku).'],
  ['Hours must be', 'Podaj poprawną liczbę godzin.'],
  ['cannot be longer than', 'Wpisany tekst jest zbyt długi.'],
  ['Choose an agreement', 'Wybierz umowę.'],
  ['category is not available', 'Wybrana kategoria nie jest dostępna.'],
  ['not found in this OSK', 'Nie znaleziono - odśwież listę i spróbuj ponownie.'],
  ['was not found', 'Nie znaleziono - odśwież listę i spróbuj ponownie.'],
];

export function readApiMessage(error: unknown): string | undefined {
  if (!(error instanceof HttpErrorResponse)) return undefined;
  return typeof error.error === 'string' ? error.error : error.error?.message ?? error.error?.title;
}

/** A Polish message for a failed agreement or course request. */
export function agreementApiError(error: unknown, fallback: string): string {
  return agreementMessage(readApiMessage(error), fallback);
}

/** A Polish version of an API message about agreements, e.g. one returned inside a result object. */
export function agreementMessage(message: string | null | undefined, fallback: string): string {
  return (message && MESSAGES.find(([fragment]) => message.includes(fragment))?.[1]) ?? fallback;
}
